<template>
<div :class="calculateWidth(0)">
    <app-lookup-modal :ref="`lookupModal${ rowIndex || '' }`" :row-index="rowIndex" :element="element" v-on:selectedRow="returnLookup"></app-lookup-modal>
    <div v-if="element.type ==='form'" class="input-group">
        <input readonly v-for="(field, index) in element.fields" v-model="model[field.column]" :id="`input-${element.id}`" :key="index" type="text" :class="`form-control col-${calculateWidth(field.width)}`" :placeholder="field.placeholder" :aria-label="field.placeholder" :aria-describedby="`button-addon-${element.id}`">
        <div class="input-group-append">
            <button data-toggle="modal" @click="fetchModalData" :data-target="`#modal-${element.id}-`" class="btn btn-outline-info" type="button" :id="`button-addon-${element.id}`"><i class="fas fa-search"></i></button>
        </div>
    </div>
    
    <div v-if="element.type ==='table'">
        <input v-for="(field, index) in element.fields" :disabled="disable" v-model="model[field.column]" :id="`input-${element.id}`" :key="index" type="text" :style="{ width: `${field.width*50}px`, float: 'left' }" :aria-label="field.placeholder" :aria-describedby="`button-addon-${element.id}`">
    </div>
    <button v-if="element.type ==='table'" data-toggle="modal" :data-target="`#modal-${element.id}-${rowIndex}`" class="btn btn-outline-info btn-sm rounded-circle" type="button" :id="`button-addon-${element.id}`" @click="fetchModalData(rowIndex)"><i class="fas fa-search"></i></button>
    
</div>
</template>

<script>
import AppLookupModal from './AppLookupModal.vue'

export default {
    props: ['headerModel','model', 'element', 'rowIndex', 'disable'],
    components: {
        AppLookupModal
    },
    methods: {
        calculateWidth(width) {
            const fieldLength = this.element.fields.length
            const totalWidth = (fieldLength === 1) ? this.element.fields[0].width : this.element.fields.reduce((prev, curr) => prev.width + curr.width)
            if(width === 0) {
                return (this.element.type === 'form') ? `form-group col-${totalWidth}` : ''
            } else {
                return (this.element.type === 'form') ?  `form-group col-${(width / totalWidth) * 12}` : ''
            }
        },
        returnLookup(data) {
            let affectedData = { }
            this.element.affectedField.forEach(x => {
                affectedData[x.to] = data[x.from]
            })
            this.$emit('selectLookup', affectedData)
        },
        setSelectedIndex(rowIndex) {
            this.$emit('selectedRowIndex', rowIndex)
        },
        fetchModalData(rowIndex) {
            this.$emit('selectedRowIndex', rowIndex)
            if(this.element.byParams) {
                let query = {
                    params: { }
                }
                for(const param of this.element.params) {
                    query.params[param.key] = (this.element.basedByHeader) ? this.headerModel[param.value] : this.model[param.value]
                }
                const payload = {
                    apiUrl: this.element.apiUrl,
                    query
                }
                this.$refs[`lookupModal${ this.rowIndex || '' }`].fetchCollectionDataByParams(payload)
            } else {
                this.$refs[`lookupModal${ this.rowIndex || '' }`].fetchCollectionData(this.element.apiUrl)
            }
        }
    }
}
</script>